module.exports = __webpack_public_path__ + "img/slider-1.f8928d67.jpg";